import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { config } from "@/config";

export const rootApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: config.API_BASE_URL,
    }),
    endpoints: () => ({}),
});
